import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { getUserToken } from './Common'

const EsignPublicRoute = () => {
    const isLoggedIn = getUserToken()

    if (isLoggedIn) {
        return <Navigate to="/esign/dashboard" replace />
    }

    return <Outlet />
}

export default EsignPublicRoute